export interface AboutSection {
  title: string;
  paragraphs: string[];
  bullets?: string[];
}

export const aboutCopyEn = {
  title: 'About WandererTrip',
  lead:
    'WandererTrip is an iPhone-first, local-first trip organizer for multi-city travel. It brings your day-by-day itinerary together with weather, quick capture, and optional AI planning—without turning your trip into a spreadsheet.',
  sections: [
    {
      title: 'What you can plan',
      paragraphs: [
        'Create trips with multiple city visits and date ranges. WandererTrip generates the days for your trip so planning stays consistent as your route changes.',
      ],
      bullets: [
        'Multi-city trips with arrival/departure dates (plus cruise port details when relevant)',
        'A day view with weather, scheduled items, notes, and “tonight’s accommodation”',
        'Per-city “Options” lists for ideas and checklists',
        'Hotel management by city (stays + confirmations)',
        'Country info reference screens (visa/embassy/currency/tipping and more)',
      ],
    },
    {
      title: 'Weather that stays useful',
      paragraphs: [
        'Weather forecasts are fetched for your city visits and cached locally. WandererTrip can also infer planning alerts (like storms, heat, wind, or heavy rain) based on forecast patterns.',
      ],
    },
    {
      title: 'Optional AI features',
      paragraphs: [
        'If you enable AI features, WandererTrip can generate a city plan (highlights + time-blocked itinerary suggestions) and help extract structured trip details from items you share into the app.',
        'AI is designed to be “review first”: you choose what gets added to your trip.',
      ],
    },
    {
      title: 'Share into the app',
      paragraphs: [
        'Use the iOS Share Sheet to send URLs, text, PDFs, and files into WandererTrip. Items land in a Shared Items inbox where you can process, review, and save them into the right trip and city.',
      ],
    },
    {
      title: 'Privacy and data model',
      paragraphs: [
        'WandererTrip is local-first: your trip data is stored on your device. Network calls are used for weather, AI (when enabled), and optional community/location sharing features (when enabled).',
      ],
    },
  ] satisfies AboutSection[],
} as const;

